export class LogLevel {
    static INFO: number = 0;
    static WARN: number = 10;
    static ERROR: number = 20;

    static allowed(level: number): boolean {
        if ([
            LogLevel.INFO,
            LogLevel.WARN,
            LogLevel.ERROR,
        ].indexOf(level) < 0) {
            return false;
        }
        return true;
    }
}
